import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import PageHeader from '../../../components/PageHeader';
import SeminarComponent from "../../../components/Seminar/Seminars";

const Seminars = () => {
  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
    shallowEqual
  );
  return (
    <>
      <PageHeader
        title={`안녕하세요, ${user && user.name}님.`}
      />
      <SeminarComponent />
    </>
  );
};

export default Seminars;